import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil-gestion.component.html',
  styleUrls: ['./accueil-gestion.component.scss']
})


export class AccueilGestionComponent implements OnInit {
  TabIndex = {
    versements : 0,
    eliminations : 1,
    consultations: 2
  };
  selectedTabIndex = this.TabIndex.versements;

  constructor(private activatedRoute: ActivatedRoute, private route: Router) { }

  ngOnInit() {
    this._getRoute();
  }

  private _getRoute(): void{
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.tab) {
        this.selectedTabIndex = this.TabIndex[params.tab];
        this.route.navigate([], {
          queryParams: {
            tab: null,
          },
          queryParamsHandling: 'merge',
        });
      }
    });
  }
}

